import { RRuleSet, rrulestr } from 'rrule';

/**
 * Reformat rrule string so that it works with rrulejs
 * @param rruleString
 */
function fixRRuleSetString(rruleString: string): string {
    const rruleSplit = rruleString.split(/,RDATE:|,EXDATE:/g);
    let dtstartString = '';
    let freqRule = '';
    if (rruleSplit.length > 0) {
        const noExDateString = rruleSplit[0];
        const rruleParts = noExDateString.split(';');
        const newRruleParts = noExDateString.split(',RRULE:');
        let restOfRule = '';
        if (newRruleParts.length > 0) {
            newRruleParts.forEach(function (part) {
                if (part.search('DTSTART:') !== -1) {
                    dtstartString = part;
                } else if (part.search('FREQ=') !== -1) {
                    freqRule = part;
                }
            });
        } else {
            rruleParts.forEach(function (part) {
                if (part.search('DTSTART=') !== -1) {
                    dtstartString = part;
                } else if (part.search('FREQ=') !== -1) {
                    const rruleIsInString = part.search('RRULE:');
                    freqRule = rruleIsInString !== -1 ? part : 'RRULE:' + part;
                } else {
                    restOfRule += part + ';';
                }
            });
            if (restOfRule) {
                restOfRule = restOfRule.substring(0, restOfRule.length - 1);
            }
            freqRule = (freqRule ? freqRule + ';' : '') + restOfRule;
        }
    }
    return [
        freqRule,
        dtstartString.replace('DTSTART=', 'DTSTART:'),
        rruleSplit.length > 1 ? 'EXDATE:' + rruleSplit[1] : '',
    ].join('\n');
}

/**
 * Converts rruleset string obtained from database into RRuleset
 * @param rruleset - RRuleSet's string representation
 */
function getRRuleSetFromString(rruleset: string): RRuleSet {
    return rrulestr(fixRRuleSetString(rruleset), { forceset: true }) as RRuleSet;
}

export { getRRuleSetFromString };
